<template>
  <nav>
    <AppBar class="p-0" :username="username" :useremail="useremail" :userinit="userinitial" />
    <v-navigation-drawer
                         v-model="mainSidebarDrawer"
                         permanent
                         dense
                         expand-on-hover
                         @transitionend="collapseSubItems()">
      <v-list dense nav rounded>
        <template v-for="(n, i) in nav">
          <v-list-item v-if="n.to && n.condition" :key="`${i}-a`" :to="n.to" link :id="n.id" @click="saveFilters(n.content)">
            <v-list-item-icon>
              <v-icon small>{{ n.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ n.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>
<script>
import AppBar from "@/components/AppBar";
import { store } from '@/store/store'
import axios from "axios";
import {saveDashboardFilters2024} from "@/config/apiEndPoints";
export default {
  name: 'NavBar',
  store,
  components: {
    AppBar,
  },
  created() {
    //console.log("Auth-"+this.$store.state.isAuth);
  },
  props: ['username', 'useremail', 'userinitial'],
  data() {
    return {
      accessValue: '',
      mainSidebarDrawer: true,
      mini: true,
    }
  },
  computed: {
    nav() {
      return [
        { to: '/', label: 'Dashboard', content: 'DASHBOARD', icon: 'mdi-home', id: 'dashboard-link', active: true, condition: true },
        { to: '/reports', label: 'Reports', content: 'REPORT', icon: 'mdi-file-chart', id: 'report-link', active: true, condition: true },
        { to: '/user', label: 'User Access', content: 'USER ACCESS', icon: 'mdi-account-circle-outline', id: 'support-link', active: false, condition: (this.$store.state.isAdmin || this.$store.state.isApprover) },
      ]
    },
  },
  methods: {
    collapseSubItems() {
      this.nav.map((item) => item.active = false)
    },
    accessUsers(data) {
      if (this.$store.state.userRole?.toUpperCase() === 'ALL') {
        return true
      }
      else if (data === 1) {
        return this.$store.state.userRole?.toUpperCase() === 'TRADE'
      }
      else if (data === 2) {
        return this.$store.state.userRole?.toUpperCase() === 'REGION'
      }
      else if (data === 3) {
        return this.$store.state.userRole?.toUpperCase() === 'VERTICAL'
      }
      else {
        return true
      }
    },
    saveFilters(value){
      let accessTokenCheck = JSON.parse(sessionStorage.getItem('av_msal_token'));
      let userEmail = accessTokenCheck.account.username;
      const idToken = accessTokenCheck.idToken;
      const headerFields = {
        headers: {
          Authorization: `Bearer ${idToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        }
      };
      let registerTopic = {
        "selectedCustomers":JSON.parse(localStorage.getItem('selectedCustomer')),
        "tradeDirectionCode":JSON.parse(localStorage.getItem('selectedTradeDirectionCodes')),
        "commercialBrands":JSON.parse(localStorage.getItem('selectedCommercialBrands')),
        "salesControlRegions":JSON.parse(localStorage.getItem('selectedSalesControlRegions')),
        "salesControlAreas":JSON.parse(localStorage.getItem('selectedSalesControlAreas')),
        "verticals":JSON.parse(localStorage.getItem('selectedVerticals')),
        "priority":JSON.parse(localStorage.getItem('selectedPriority')),
        "validityGroup":JSON.parse(localStorage.getItem('selectedValidityGroup')),
        "country":JSON.parse(localStorage.getItem('selectedCountry')),
        "cargoType":JSON.parse(localStorage.getItem('selectedCargoType')),
        "pic":localStorage.getItem('selectedPic'),
        "category":JSON.parse(localStorage.getItem('selectedCategory')),
        "tab":localStorage.getItem('selectedTab'),
        "intraTrades":JSON.parse(localStorage.getItem('selectedLongShorthaul')),
        "menu":value,
        "loggedInUser":userEmail
      }
      axios.post(`${saveDashboardFilters2024}`,registerTopic,headerFields)
          .then(response => {
            if (response.status === 200) {
              localStorage.setItem("selectedMenu",value);
            } else {
              console.error('API request failed with status:', response.status);
            }
          })
          .catch(error => {
            console.error('Error loading data:', error);
          });
    },

  },
}
</script>
<style scoped>
.theme--light.v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 24px !important;
}
</style>
